import { styled } from '@linaria/react';

import { Skeleton } from '~shared/ui/atoms/Skeleton';

import { gridItemWrapperStyle } from '../styles';

export const GridItemWrapper = styled.div`
	${gridItemWrapperStyle};
	position: relative;
`;

export const OtherContentSkeleton = styled(Skeleton)`
	height: 30px;
	border-radius: var(--radius-xs);
`;
